// Core
import { Map } from 'immutable';
import { handleActions } from 'redux-actions';

// Instruments
import { offersActions } from './actions';

const initalState = Map({
    store:  Map(),
    status: Map(),
});

export const offersReducer = handleActions(
    {
        [offersActions.addOffers]: (state, { payload: offers }) => {
            return state
                .mergeIn(['store'], Map(offers))
                .mergeIn(['status'], Map(offers).map(() => 'alive'));
        },
        [offersActions.setExpired]: (state, { payload: offerId }) => {
            return state.setIn(['status', offerId], 'expired');
        },
    },
    initalState
);
